module.exports = __webpack_public_path__ + "76c3b6433049d1bbb4ee67d4f3c20025.pdf";